import React from "react";
import { Input, Spin, Space, Form, Result, Switch } from "antd";
import { Edit, useForm } from "@refinedev/antd";
import { useParams } from "react-router-dom";
import { Authenticated, CanAccess, useTranslate } from "@refinedev/core";
import { ConfigurationResponse } from "@/types";

export const FlagEditPage: React.FC = () => {
  const t = useTranslate();
  const { id } = useParams<{ id: string }>();
  const { formProps, saveButtonProps } = useForm<ConfigurationResponse>({
    resource: "api/configuration",
    id: id,
    action: "edit",
  });
  if (!formProps?.initialValues) return <Spin />;
  return (
    <Authenticated key="feature_flags_edit">
      <CanAccess
        resource="feature_flags"
        action="edit"
        fallback={
          <Result
            status={403}
            title={t("pages.system.detail.accessForbidden")}
          />
        }
      >
        <Edit
          saveButtonProps={saveButtonProps}
          wrapperProps={{
            style: { maxWidth: 800, margin: "auto" },
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Form {...formProps} layout="vertical">
              <Form.Item
                name="value"
                label={t("featureFlags.index.value")}
                getValueFromEvent={String}
                getValueProps={(value) => ({
                  checked: value === "true",
                })}
              >
                <Switch />
              </Form.Item>
              <Form.Item
                label={t("featureFlags.index.type")}
                rules={[{ required: true }]}
                name="type"
              >
                <Input placeholder="type" />
              </Form.Item>
            </Form>
          </Space>
        </Edit>
      </CanAccess>
    </Authenticated>
  );
};
